import { render } from "./DetailedReportCards.vue?vue&type=template&id=4c367559&scoped=true"
import script from "./DetailedReportCards.vue?vue&type=script&lang=js"
export * from "./DetailedReportCards.vue?vue&type=script&lang=js"

import "./DetailedReportCards.vue?vue&type=style&index=0&id=4c367559&lang=scss&scoped=true"

import exportComponent from "F:\\ei-projects\\ei-adult-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c367559"]])

export default __exports__